import {
  Action,
  ActionType,
  IFullStressScoringResponse,
} from "models/stressCheck/fullStressScoringInformation";

import createReducer from "redux/createReducer";

export interface FullStressScoringReducerType {
  loading: boolean;
  error?: any;
  fullStressScoringResponse?: IFullStressScoringResponse;
}

const defaultState: FullStressScoringReducerType = {
  loading: false,
  error: null,
  fullStressScoringResponse: undefined,
};

export const fullStressScoringReducer =
  createReducer<FullStressScoringReducerType>(defaultState, {
    [ActionType.FULL_STRESS_SCORING](state: FullStressScoringReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.FULL_STRESS_SCORING_ERROR](
      state: FullStressScoringReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.FULL_STRESS_SCORING_SUCCESS](
      state: FullStressScoringReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        fullStressScoringResponse: action.payload,
      };
    },

    [ActionType.FULL_STRESS_SCORING_RESET](
      state: FullStressScoringReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        fullStressScoringResponse: undefined,
      };
    },
  });
